var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"mb-4"},[_c('v-alert',{attrs:{"type":"success","dismissible":"","close-text":"Close Alert"}},[_vm._v(" Last imported invoice date was "+_vm._s(_vm.latestXeroUpdate)+", Go to Xero -> Invoices to refresh Xero data if necessary ")]),_c('router-view',{staticClass:"view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }